import React, { useState, useEffect, useRef } from "react";
import "../assets/css/Campaigns.css";
import "../assets/css/Vox.css";
import Sidebar from "../components/sidebar";
import ScriptDetail from "../components/scriptDetail";
import config from "../config";
import "../assets/css/Stat.css";
import "../assets/css/Phone-section.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import { useUser } from "../context/UserContext";
import { handleContactCall } from "../utils/common/helpers";

function ContactCallPage({ contentMinimized, onClose }) {
     const location = useLocation();
//   const data = location.state;
//     console.log("ContactCallPage data:", data);

  const { contactId, number, callSid } = useParams(); 
  const [loading, setLoading] = useState(false);
  const [campaignData, setCampaignData] = useState(null);
  const [callStatus, setCallStatus] = useState("");
  const [updateContactformErrors, setupdateContactformErrors] = useState({});
  const [notes, setNotes] = useState([]);
  const navigate = useNavigate();
  const isMountedRef = useRef(true);
  const timeoutRef = useRef(null);
  const [data, setData] = useState(null);
  const [dispositionData, setDispositionData] = useState([]);

  const [updateContactData, setUpdateContactData] = useState({
    name: data?.contact?.name || "",
    last_name: data?.contact?.last_name || "",
    contact_primary: data?.contact?.contact_primary,
    company: data?.contact?.company,
    street: data?.contact?.street || "",
    city: data?.contact?.city || "",
    state: data?.contact?.state || "",
    country: data?.contact?.country || "",
    title: "",
    contact_id: data?.contact?.id,
    // registration_number: data?.contact?.registration_number,
    name: data?.contact?.name,
    // id: contactId,
    vertical_type: data?.contact?.vertical_type,
    order_id: data?.contact?.order_id,
    caller_type: data?.contact?.caller_type,
    interaction_type: data?.contact?.interaction_type,
    interaction_category: data?.contact?.interaction_category,
    interaction_sub_category: data?.contact?.interaction_sub_category,
    note: data?.contact?.note,
    ticket_required: data?.contact?.ticket_required,
    parse_id: data?.contact?.parse_id,
    city_id: data?.contact?.city_id,
  });
  const { user } = useUser();

  useEffect(() => {
    async function fetchCallData() {
      const response = await handleContactCall(number, contactId, undefined, '', 0);
      // const response = {
      //   success: true, data: {contact: {name: "Test Call"}}
      // } ;
       if(response && response.success){
        setData(response.data);
        const data = response.data;
        setUpdateContactData({
          name: data?.contact?.name || "",
          last_name: data?.contact?.last_name || "",
          contact_primary:number,
          company: data?.contact?.company,
          street: data?.contact?.street || "",
          city: data?.contact?.city || "",
          state: data?.contact?.state || "",
          country: data?.contact?.country || "",
          title: "",
          contact_id: data?.contact?.id,
          // registration_number: data?.contact?.registration_number,
          name: data?.contact?.name,
          // id: data?.contact?.id,
          vertical_type: data?.contact?.vertical_type,
          order_id: data?.contact?.order_id,
          caller_type: data?.contact?.caller_type,
          interaction_type: data?.contact?.interaction_type,
          interaction_category: data?.contact?.interaction_category,
          interaction_sub_category: data?.contact?.interaction_sub_category,
          note: data?.contact?.note,
          ticket_required: data?.contact?.ticket_required,
          parse_id: data?.contact?.parse_id,
          city_id: data?.contact?.city_id,
        })

         const token = localStorage.getItem("token");
         const res = await fetch(
           `${config.apiBaseUrl}/api/v1/reports/${number}/call-disposition?limit=5`,
           {
             headers: {
               Authorization: `Bearer ${token}`,
             },
           }
         );
         const disResult = await res.json();
         if (disResult && disResult.success) {
           setDispositionData(disResult.data); 
           const latestNote = disResult.data[0];
           setUpdateContactData((prevData) => ({
             ...prevData,
             registration_number: latestNote?.registration_number,
             id: latestNote?.dis_id,
           }))
         }

              toast.success("Call successfull");
              // setContactCallModalData(response.data)
              // setShowContactCallModal(true);
              // navigate(`/contact-call/${contactId}`, { state: response.data });
      
            } else {
              if (response.error?.explanation && response.error.explanation.length > 0) {
                toast.error(response.error.explanation.join(", "));
              } else {
                toast.error(response.message || "Call failed");
              }
            }
    }

    fetchCallData();
  }, [contactId, number]);

  const OPTIONS_VERTICAL_TYPE = [
    { label: "Parcel", value: 1 },
    { label: "Ride", value: 2 },
    { label: "Food", value: 3 },
    { label: "Rental", value: 4 },
    { label: "Realtime Parcel", value: 5 },
    { label: "Bazar", value: 6 },
  ]

  const CALLER_TYPE_OPTIONS = {
    1: [
      { label: "Merchant", value: 1 },
      { label: "User", value: 2 },
      { label: "Delivery Agent", value: 3 },
      { label: "Pickup Agent", value: 4 },
      { label: "Hub", value: 15 }
    ],
    2: [
      { label: "Rider", value: 5 },
      { label: "Captain", value: 6 },
      { label: "Tuk Tuk Chalak", value: 7 },
      { label: "User", value: 2 }
    ],
    3: [
      { label: "Pathao Hero", value: 8 },
      { label: "Restaurant", value: 9 },
      { label: "User", value: 2 }
    ],
    4: [
      { label: "Captain", value: 6 },
      { label: "User", value: 2 },
      { label: "Rental Company", value: 10 }
    ],
    5: [
      { label: "Realtime Parcel", value: 11 },
      { label: "Rider", value: 5 },
      { label: "S. User", value: 13 },
      { label: "R. User", value: 14 }
    ],
    6: [
      { label: "Rider", value: 5 },
      { label: "Captain", value: 6 },
      { label: "Tuk Tuk Chalak", value: 7 },
      { label: "User", value: 2 }
    ]
  };

  const INTERACTION_CATEGORY = {
    "1": [
      { "label": "Delivery Related", "value": 101 },
      { "label": "Exchange Related", "value": 102 },
      { "label": "Order Related", "value": 103 },
      { "label": "Payment Related", "value": 104 },
      { "label": "Pick Up Related", "value": 105 },
      { "label": "Return Related", "value": 106 },
      { "label": "Rider Related", "value": 107 },
      { "label": "Unwanted Calls", "value": 108 },
      { "label": "General Category", "value": 109 }
    ],
    "2": [
      { label: "Account / Profile / Document Related", value: 201 },
      { label: "Account & Profile Management", value: 202 },
      { label: "Against Rules Suspension/Unsuspension Related", value: 203 },
      { label: "App & Technical Issues", value: 204 },
      { label: "Bag / Merchandise / Distribution", value: 205 },
      { label: "Branding Marketing Promotion", value: 206 },
      { label: "Break", value: 207 },
      { label: "Campaign", value: 208 },
      { label: "Cart & Order Management", value: 209 },
      { label: "City Change", value: 210 },
      { label: "Complaint Related", value: 211 },
      { label: "CR", value: 212 },
      { label: "Driver Type Change", value: 213 },
      { label: "Due Payment", value: 214 },
      { label: "e Support", value: 215 },
      { label: "ER Food Cancellation", value: 216 },
      { label: "Fare Related", value: 217 },
      { label: "Feedback / Suggestion", value: 218 },
      { label: "Follow Up Call", value: 219 },
      { label: "Food Order Complaints", value: 220 },
      { label: "General Query / Service Related", value: 221 },
      { label: "Geo Fence Availability", value: 222 },
      { label: "Help From Office Side", value: 223 },
      { label: "Insurance / Accident Related", value: 224 },
      { label: "Location", value: 225 },
      { label: "Navigation", value: 226 },
      { label: "New Registration / Training Related", value: 227 },
      { label: "Order related", value: 228 },
      { label: "Realtime Parcel Service Related", value: 229 },
      { label: "Realtime Parcel, Ride and Order Cancellation", value: 230 },
      { label: "Pathao Benefit Details", value: 231 },
      { label: "Pathao Letterhead", value: 232 },
      { label: "Pathao Points", value: 233 },
      { label: "Payment Inquiry", value: 234 },
      { label: "Payment Related", value: 235 },
      { label: "Personal Information", value: 236 },
      { label: "PH Support Related", value: 237 },
      { label: "Quest", value: 238 },
      { label: "Quest, Promo, Campaign & Referral", value: 239 },
      { label: "Rental Cancellation", value: 240 },
      { label: "Rental Services", value: 241 },
      { label: "Restaurant App Dashboard Visibility", value: 242 },
      { label: "Restaurant Related Issues", value: 243 },
      { label: "Ride / Trip Related Issues", value: 244 },
      { label: "Ride Booking / Ride Service", value: 245 },
      { label: "Saver Plans", value: 246 },
      { label: "Switch Car", value: 247 },
      { label: "Traffic Caught", value: 248 },
      { label: "Unwanted Calls", value: 249 },
      { label: "PH Support Related", value: 250 },
      { label: "Follow Up Call", value: 251 },
      { label: "Against Rules Suspension/Unsuspension Related", value: 252 },
      { label: "Complaint Related", value: 253 },
      { label: "General Query / Service Related", value: 254 },
      { label: "No Commission", value: 255 },
    ],
    "3": [
      { label: "Account / Profile / Document Related", value: 201 },
      { label: "Account & Profile Management", value: 202 },
      { label: "Against Rules Suspension/Unsuspension Related", value: 203 },
      { label: "App & Technical Issues", value: 204 },
      { label: "Bag / Merchandise / Distribution", value: 205 },
      { label: "Branding Marketing Promotion", value: 206 },
      { label: "Break", value: 207 },
      { label: "Campaign", value: 208 },
      { label: "Cart & Order Management", value: 209 },
      { label: "City Change", value: 210 },
      { label: "Complaint Related", value: 211 },
      { label: "CR", value: 212 },
      { label: "Driver Type Change", value: 213 },
      { label: "Due Payment", value: 214 },
      { label: "e Support", value: 215 },
      { label: "ER Food Cancellation", value: 216 },
      { label: "Fare Related", value: 217 },
      { label: "Feedback / Suggestion", value: 218 },
      { label: "Follow Up Call", value: 219 },
      { label: "Food Order Complaints", value: 220 },
      { label: "General Query / Service Related", value: 221 },
      { label: "Geo Fence Availability", value: 222 },
      { label: "Help From Office Side", value: 223 },
      { label: "Insurance / Accident Related", value: 224 },
      { label: "Location", value: 225 },
      { label: "Navigation", value: 226 },
      { label: "New Registration / Training Related", value: 227 },
      { label: "Order related", value: 228 },
      { label: "Realtime Parcel Service Related", value: 229 },
      { label: "Realtime Parcel, Ride and Order Cancellation", value: 230 },
      { label: "Pathao Benefit Details", value: 231 },
      { label: "Pathao Letterhead", value: 232 },
      { label: "Pathao Points", value: 233 },
      { label: "Payment Inquiry", value: 234 },
      { label: "Payment Related", value: 235 },
      { label: "Personal Information", value: 236 },
      { label: "PH Support Related", value: 237 },
      { label: "Quest", value: 238 },
      { label: "Quest, Promo, Campaign & Referral", value: 239 },
      { label: "Rental Cancellation", value: 240 },
      { label: "Rental Services", value: 241 },
      { label: "Restaurant App Dashboard Visibility", value: 242 },
      { label: "Restaurant Related Issues", value: 243 },
      { label: "Ride / Trip Related Issues", value: 244 },
      { label: "Ride Booking / Ride Service", value: 245 },
      { label: "Saver Plans", value: 246 },
      { label: "Switch Car", value: 247 },
      { label: "Traffic Caught", value: 248 },
      { label: "Unwanted Calls", value: 249 },
      { label: "PH Support Related", value: 250 },
      { label: "Follow Up Call", value: 251 },
      { label: "Against Rules Suspension/Unsuspension Related", value: 252 },
      { label: "Complaint Related", value: 253 },
      { label: "General Query / Service Related", value: 254 },
      { label: "No Commission", value: 255 },
    ],
    "4": [
      { label: "Account / Profile / Document Related", value: 201 },
      { label: "Account & Profile Management", value: 202 },
      { label: "Against Rules Suspension/Unsuspension Related", value: 203 },
      { label: "App & Technical Issues", value: 204 },
      { label: "Bag / Merchandise / Distribution", value: 205 },
      { label: "Branding Marketing Promotion", value: 206 },
      { label: "Break", value: 207 },
      { label: "Campaign", value: 208 },
      { label: "Cart & Order Management", value: 209 },
      { label: "City Change", value: 210 },
      { label: "Complaint Related", value: 211 },
      { label: "CR", value: 212 },
      { label: "Driver Type Change", value: 213 },
      { label: "Due Payment", value: 214 },
      { label: "e Support", value: 215 },
      { label: "ER Food Cancellation", value: 216 },
      { label: "Fare Related", value: 217 },
      { label: "Feedback / Suggestion", value: 218 },
      { label: "Follow Up Call", value: 219 },
      { label: "Food Order Complaints", value: 220 },
      { label: "General Query / Service Related", value: 221 },
      { label: "Geo Fence Availability", value: 222 },
      { label: "Help From Office Side", value: 223 },
      { label: "Insurance / Accident Related", value: 224 },
      { label: "Location", value: 225 },
      { label: "Navigation", value: 226 },
      { label: "New Registration / Training Related", value: 227 },
      { label: "Order related", value: 228 },
      { label: "Realtime Parcel Service Related", value: 229 },
      { label: "Realtime Parcel, Ride and Order Cancellation", value: 230 },
      { label: "Pathao Benefit Details", value: 231 },
      { label: "Pathao Letterhead", value: 232 },
      { label: "Pathao Points", value: 233 },
      { label: "Payment Inquiry", value: 234 },
      { label: "Payment Related", value: 235 },
      { label: "Personal Information", value: 236 },
      { label: "PH Support Related", value: 237 },
      { label: "Quest", value: 238 },
      { label: "Quest, Promo, Campaign & Referral", value: 239 },
      { label: "Rental Cancellation", value: 240 },
      { label: "Rental Services", value: 241 },
      { label: "Restaurant App Dashboard Visibility", value: 242 },
      { label: "Restaurant Related Issues", value: 243 },
      { label: "Ride / Trip Related Issues", value: 244 },
      { label: "Ride Booking / Ride Service", value: 245 },
      { label: "Saver Plans", value: 246 },
      { label: "Switch Car", value: 247 },
      { label: "Traffic Caught", value: 248 },
      { label: "Unwanted Calls", value: 249 },
      { label: "PH Support Related", value: 250 },
      { label: "Follow Up Call", value: 251 },
      { label: "Against Rules Suspension/Unsuspension Related", value: 252 },
      { label: "Complaint Related", value: 253 },
      { label: "General Query / Service Related", value: 254 },
      { label: "No Commission", value: 255 },
    ],
    "5": [
      { label: "Account / Profile / Document Related", value: 201 },
      { label: "Account & Profile Management", value: 202 },
      { label: "Against Rules Suspension/Unsuspension Related", value: 203 },
      { label: "App & Technical Issues", value: 204 },
      { label: "Bag / Merchandise / Distribution", value: 205 },
      { label: "Branding Marketing Promotion", value: 206 },
      { label: "Break", value: 207 },
      { label: "Campaign", value: 208 },
      { label: "Cart & Order Management", value: 209 },
      { label: "City Change", value: 210 },
      { label: "Complaint Related", value: 211 },
      { label: "CR", value: 212 },
      { label: "Driver Type Change", value: 213 },
      { label: "Due Payment", value: 214 },
      { label: "e Support", value: 215 },
      { label: "ER Food Cancellation", value: 216 },
      { label: "Fare Related", value: 217 },
      { label: "Feedback / Suggestion", value: 218 },
      { label: "Follow Up Call", value: 219 },
      { label: "Food Order Complaints", value: 220 },
      { label: "General Query / Service Related", value: 221 },
      { label: "Geo Fence Availability", value: 222 },
      { label: "Help From Office Side", value: 223 },
      { label: "Insurance / Accident Related", value: 224 },
      { label: "Location", value: 225 },
      { label: "Navigation", value: 226 },
      { label: "New Registration / Training Related", value: 227 },
      { label: "Order related", value: 228 },
      { label: "Realtime Parcel Service Related", value: 229 },
      { label: "Realtime Parcel, Ride and Order Cancellation", value: 230 },
      { label: "Pathao Benefit Details", value: 231 },
      { label: "Pathao Letterhead", value: 232 },
      { label: "Pathao Points", value: 233 },
      { label: "Payment Inquiry", value: 234 },
      { label: "Payment Related", value: 235 },
      { label: "Personal Information", value: 236 },
      { label: "PH Support Related", value: 237 },
      { label: "Quest", value: 238 },
      { label: "Quest, Promo, Campaign & Referral", value: 239 },
      { label: "Rental Cancellation", value: 240 },
      { label: "Rental Services", value: 241 },
      { label: "Restaurant App Dashboard Visibility", value: 242 },
      { label: "Restaurant Related Issues", value: 243 },
      { label: "Ride / Trip Related Issues", value: 244 },
      { label: "Ride Booking / Ride Service", value: 245 },
      { label: "Saver Plans", value: 246 },
      { label: "Switch Car", value: 247 },
      { label: "Traffic Caught", value: 248 },
      { label: "Unwanted Calls", value: 249 },
      { label: "PH Support Related", value: 250 },
      { label: "Follow Up Call", value: 251 },
      { label: "Against Rules Suspension/Unsuspension Related", value: 252 },
      { label: "Complaint Related", value: 253 },
      { label: "General Query / Service Related", value: 254 },
      { label: "No Commission", value: 255 },
    ],
    "6": [
      { label: "Account / Profile / Document Related", value: 201 },
      { label: "Account & Profile Management", value: 202 },
      { label: "Against Rules Suspension/Unsuspension Related", value: 203 },
      { label: "App & Technical Issues", value: 204 },
      { label: "Bag / Merchandise / Distribution", value: 205 },
      { label: "Branding Marketing Promotion", value: 206 },
      { label: "Break", value: 207 },
      { label: "Campaign", value: 208 },
      { label: "Cart & Order Management", value: 209 },
      { label: "City Change", value: 210 },
      { label: "Complaint Related", value: 211 },
      { label: "CR", value: 212 },
      { label: "Driver Type Change", value: 213 },
      { label: "Due Payment", value: 214 },
      { label: "e Support", value: 215 },
      { label: "ER Food Cancellation", value: 216 },
      { label: "Fare Related", value: 217 },
      { label: "Feedback / Suggestion", value: 218 },
      { label: "Follow Up Call", value: 219 },
      { label: "Food Order Complaints", value: 220 },
      { label: "General Query / Service Related", value: 221 },
      { label: "Geo Fence Availability", value: 222 },
      { label: "Help From Office Side", value: 223 },
      { label: "Insurance / Accident Related", value: 224 },
      { label: "Location", value: 225 },
      { label: "Navigation", value: 226 },
      { label: "New Registration / Training Related", value: 227 },
      { label: "Order related", value: 228 },
      { label: "Realtime Parcel Service Related", value: 229 },
      { label: "Realtime Parcel, Ride and Order Cancellation", value: 230 },
      { label: "Pathao Benefit Details", value: 231 },
      { label: "Pathao Letterhead", value: 232 },
      { label: "Pathao Points", value: 233 },
      { label: "Payment Inquiry", value: 234 },
      { label: "Payment Related", value: 235 },
      { label: "Personal Information", value: 236 },
      { label: "PH Support Related", value: 237 },
      { label: "Quest", value: 238 },
      { label: "Quest, Promo, Campaign & Referral", value: 239 },
      { label: "Rental Cancellation", value: 240 },
      { label: "Rental Services", value: 241 },
      { label: "Restaurant App Dashboard Visibility", value: 242 },
      { label: "Restaurant Related Issues", value: 243 },
      { label: "Ride / Trip Related Issues", value: 244 },
      { label: "Ride Booking / Ride Service", value: 245 },
      { label: "Saver Plans", value: 246 },
      { label: "Switch Car", value: 247 },
      { label: "Traffic Caught", value: 248 },
      { label: "Unwanted Calls", value: 249 },
      { label: "PH Support Related", value: 250 },
      { label: "Follow Up Call", value: 251 },
      { label: "Against Rules Suspension/Unsuspension Related", value: 252 },
      { label: "Complaint Related", value: 253 },
      { label: "General Query / Service Related", value: 254 },
      { label: "No Commission", value: 255 },
    ],
  };

  const INTERACTION_SUB_CATEGORIES = {
    "101": [
      {
        "label": "Order Delivery Time Query",
        "value": 10101,
        "interactionType": 1
      },
      {
        "label": "Urgent Delivery Request",
        "value": 10102,
        "interactionType": 3
      },
      {
        "label": "Delay in Delivery",
        "value": 10103,
        "interactionType": 2
      },
      {
        "label": "Delivery Status Query",
        "value": 10104,
        "interactionType": 1
      },
      {
        "label": "Call Request to Customer",
        "value": 10105,
        "interactionType": 3
      },
      {
        "label": "Coverage Area Query",
        "value": 10106,
        "interactionType": 1
      },
      {
        "label": "Parcel Swapped Complaint",
        "value": 10107,
        "interactionType": 2
      },
      {
        "label": "Delivery not Attempted by Agent",
        "value": 10108,
        "interactionType": 2
      }
    ],
    "102": [
      {
        "label": "Exchange Charge Query",
        "value": 10201,
        "interactionType": 1
      },
      {
        "label": "Exchange Order Return Request",
        "value": 10202,
        "interactionType": 3
      },
      {
        "label": "Delay in Exchange",
        "value": 10203,
        "interactionType": 2
      },
      {
        "label": "Delay in Exchange Return",
        "value": 10204,
        "interactionType": 2
      },
      {
        "label": "Exchange Request due to Merchant Issue",
        "value": 10205,
        "interactionType": 3
      }
    ],
    "103": [
      {
        "label": "Price Change Request",
        "value": 10301,
        "interactionType": 3
      },
      {
        "label": "Number Change Request",
        "value": 10302,
        "interactionType": 3
      },
      {
        "label": "Order Cancel Request",
        "value": 10303,
        "interactionType": 3
      },
      {
        "label": "Order Create Request",
        "value": 10304,
        "interactionType": 3
      },
      {
        "label": "Location Verification",
        "value": 10305,
        "interactionType": 1
      },
      {
        "label": "Alternative Number Query",
        "value": 10306,
        "interactionType": 1
      },
      {
        "label": "Wrong Status Update Complaint",
        "value": 10307,
        "interactionType": 2
      },
      {
        "label": "Order Hold Request",
        "value": 10308,
        "interactionType": 3
      },
      {
        "label": "COD Verification",
        "value": 10309,
        "interactionType": 1
      },
      {
        "label": "Order Damage Complaint",
        "value": 10310,
        "interactionType": 2
      },
      {
        "label": "Order Misplace Complaint",
        "value": 10311,
        "interactionType": 2
      },
      {
        "label": "Location Change Request",
        "value": 10312,
        "interactionType": 3
      },
      {
        "label": "Packaging Guideliness Query",
        "value": 10313,
        "interactionType": 1
      },
      {
        "label": "System Related Query",
        "value": 10314,
        "interactionType": 1
      },
      {
        "label": "Order Not Sorted",
        "value": 10315,
        "interactionType": 2
      },
      {
        "label": "Weight Miscalculated Complaint",
        "value": 10316,
        "interactionType": 1
      },
      {
        "label": "Not able to Create Order through Panel",
        "value": 10317,
        "interactionType": 2
      },
      {
        "label": "Order Created Late - Verification Request",
        "value": 10318,
        "interactionType": 3
      }
    ],
    "104": [
      {
        "label": "Payment not Received",
        "value": 10401,
        "interactionType": 2
      },
      {
        "label": "Delivery Charges Query",
        "value": 10402,
        "interactionType": 1
      },
      {
        "label": "Refund Related Query",
        "value": 10403,
        "interactionType": 1
      },
      {
        "label": "Merchant Receiveable Payment Query",
        "value": 10404,
        "interactionType": 1
      },
      {
        "label": "Why COD was paid less?",
        "value": 10405,
        "interactionType": 1
      },
      {
        "label": "Delivery Fee Overcharge due to System Error",
        "value": 10406,
        "interactionType": 2
      },
      {
        "label": "Ledger/Tax invoice Request",
        "value": 10407,
        "interactionType": 3
      }
    ],
    "105": [
      {
        "label": "Pick Up Request",
        "value": 10501,
        "interactionType": 3
      },
      {
        "label": "Pick Up Delay Complaint",
        "value": 10502,
        "interactionType": 2
      },
      {
        "label": "Order Not Picked Complaint",
        "value": 10503,
        "interactionType": 2
      }
    ],
    "106": [
      {
        "label": "Return Charge Query",
        "value": 10601,
        "interactionType": 1
      },
      {
        "label": "Delay in Return for IV",
        "value": 10602,
        "interactionType": 2
      },
      {
        "label": "Delay in Return for OV",
        "value": 10603,
        "interactionType": 2
      },
      {
        "label": "Final Redelivery Request",
        "value": 10604,
        "interactionType": 3
      },
      {
        "label": "Return Process Query",
        "value": 10605,
        "interactionType": 1
      },
      {
        "label": "Reverse Pick Up Request",
        "value": 10606,
        "interactionType": 3
      },
      {
        "label": "Order Return Request",
        "value": 10607,
        "interactionType": 3
      }
    ],
    "107": [
      {
        "label": "Misbehaviour by DA Complaint",
        "value": 10701,
        "interactionType": 4
      },
      {
        "label": "Misbehaviour by PA Complaint",
        "value": 10702,
        "interactionType": 4
      },
      {
        "label": "Extra Charges Complaint",
        "value": 10703,
        "interactionType": 2
      },
      {
        "label": "Rider Details Inquery",
        "value": 10704,
        "interactionType": 1
      },
      {
        "label": "Breach of Close Box Policy",
        "value": 10705,
        "interactionType": 2
      }
    ],
    "108": [
      {
        "label": "Silent Calls",
        "value": 10801,
        "interactionType": 5
      },
      {
        "label": "Slang Calls",
        "value": 10802,
        "interactionType": 5
      },
      {
        "label": "Unwanted Calls",
        "value": 10803,
        "interactionType": 5
      }
    ],
    "109": [
      {
        "label": "Interested to Join as Merchant",
        "value": 10901,
        "interactionType": 1
      },
      {
        "label": "Merchant info update",
        "value": 10902,
        "interactionType": 3
      },
      {
        "label": "Interested to Join as Agent",
        "value": 10903,
        "interactionType": 1
      },
      {
        "label": "Call back Request",
        "value": 10904,
        "interactionType": 3
      },
      {
        "label": "Promo not Applied Complaint",
        "value": 10905,
        "interactionType": 2
      },
      {
        "label": "OTP not received while Pick Up",
        "value": 10906,
        "interactionType": 2
      },
      {
        "label": "OTP not received while Return",
        "value": 10907,
        "interactionType": 2
      },
      {
        "label": "Unable to Create Ticket",
        "value": 10908,
        "interactionType": 2
      },
      {
        "label": "Unable to Create Order",
        "value": 10909,
        "interactionType": 2
      },
      {
        "label": "Merchant unaware of Reverse/Exchange Order Creation",
        "value": 10910,
        "interactionType": 1
      },
      {
        "label": "Customer requested to check Parcel",
        "value": 10911,
        "interactionType": 1
      },
      {
        "label": "Outbound Call",
        "value": 10912,
        "interactionType": 1
      },
      {
        "label": "Realtime Parcel Query",
        "value": 10913,
        "interactionType": 1
      },
      {
        "label": "Other Vertical Query",
        "value": 10914,
        "interactionType": 1
      },
      {
        "label": "Not able to login Panel",
        "value": 10915,
        "interactionType": 2
      },
      {
        "label": "C2C Service",
        "value": 10916,
        "interactionType": 1
      }
    ],
    "110": [
      {
        "label": "Ledger/Tax invoice Request",
        "value": 11001,
        "interactionType": 3
      }
    ],
    "201": [
      {
        "label": "How To Get Verified",
        "value": 20101,
        "interactionType": 1
      },
      {
        "label": "Trained But Not Verified",
        "value": 20102,
        "interactionType": 2
      },
      {
        "label": "Personal Info Phone Number Change",
        "value": 20103,
        "interactionType": 3
      },
      {
        "label": "Personal Info Document Change / Insufficient Docs",
        "value": 20104,
        "interactionType": 3
      },
      {
        "label": "Document Update",
        "value": 20105,
        "interactionType": 3
      },
      {
        "label": "Password Change",
        "value": 20106,
        "interactionType": 3
      },
      {
        "label": "Document Request For Evidence",
        "value": 20107,
        "interactionType": 3
      },
      {
        "label": "Request Block Query",
        "value": 20108,
        "interactionType": 1
      },
      {
        "label": "Acc Not Verified",
        "value": 20109,
        "interactionType": 1
      },
    ],
    "202": [
      {
        "label": "Delete Account",
        "value": 20201,
        "interactionType": 3
      },
      {
        "label": "Personal Account Information Profile Picture Change",
        "value": 20202,
        "interactionType": 3
      },
      {
        "label": "Personal Account Information License Update Request",
        "value": 20203,
        "interactionType": 3
      },
      {
        "label": "Inquiry Details Information Customer",
        "value": 20204,
        "interactionType": 1
      }
    ],
    "203": [
      {
        "label": "Suspension Inquiry Due Exceed / Bike Sold",
        "value": 20301,
        "interactionType": 1
      },
      {
        "label": "Suspension Inquiry Start & End",
        "value": 20302,
        "interactionType": 1
      },
      {
        "label": "Suspension Inquiry Misbehaviour",
        "value": 20303,
        "interactionType": 1
      },
      {
        "label": "Against Rules Not Taking Online Trip",
        "value": 20304,
        "interactionType": 2
      },
      {
        "label": "Against Rules Promo Discount Not Given",
        "value": 20305,
        "interactionType": 2
      },
      {
        "label": "Against Rules Deliberately Start & End",
        "value": 20306,
        "interactionType": 2
      },
      {
        "label": "Against Rules Unregistered Vehicle",
        "value": 20307,
        "interactionType": 2
      },
      {
        "label": "Against Rules Driver Id Shared",
        "value": 20308,
        "interactionType": 2
      },
      {
        "label": "Extremely Poor Behaviour Offensive/Slang Words",
        "value": 20309,
        "interactionType": 2
      },
      {
        "label": "Unsuspension Inquiry",
        "value": 20310,
        "interactionType": 3
      },
      {
        "label": "Start & End Same Location Words",
        "value": 20311,
        "interactionType": 2
      },
      {
        "label": "Complaint Offline Trip",
        "value": 20312,
        "interactionType": 2
      },
      {
        "label": "Offering Offline Trip",
        "value": 20313,
        "interactionType": 1
      },
      {
        "label": "Suspension Inquiry Offering Offline Trip",
        "value": 20314,
        "interactionType": 1
      },
      {
        "label": "Extremely Poor Behaviour_Asked for Personal Info",
        "value": 20315,
        "interactionType": 1
      },
      {
        "label": "Trying To Overcharge Customer",
        "value": 20316,
        "interactionType": 2
      },
      {
        "label": "Reckless Driving / Speeding",
        "value": 20317,
        "interactionType": 2
      },
      {
        "label": "Drink And Drive",
        "value": 20318,
        "interactionType": 2
      },
      {
        "label": "Harassment",
        "value": 20319,
        "interactionType": 2
      },
      {
        "label": "Poor Behaviour / Rude Behaviour",
        "value": 20320,
        "interactionType": 2
      },
       {
      "label": "Asking Personal Questions",
      "value": 20321,
      "interactionType": 2
    },
    {
      "label": "Quest Fraud",
      "value": 20322,
      "interactionType": 2
    },
    {
      "label": "Unregistered Vehicle",
      "value": 20323,
      "interactionType": 2
    },
    {
      "label": "Suspension Inquiry Against Rules",
      "value": 20324,
      "interactionType": 1
    },
    {
      "label": "Suspension Inquiry Promo Fraud",
      "value": 20325,
      "interactionType": 1
    },
    {
      "label": "Suspension Inquiry Defuse To Go Pick Up Destination",
      "value": 20326,
      "interactionType": 1
    },
    {
      "label": "Suspension Inquiry Extremely Poor Behaviour Verbal/Sexual Harassment",
      "value": 20327,
      "interactionType": 1
    },
    {
      "label": "Suspension Inquiry Offline Trip",
      "value": 20328,
      "interactionType": 1
    },
    {
      "label": "Suspension Inquiry Trip Outside Of Pathao App",
      "value": 20329,
      "interactionType": 1
    },
    {
      "label": "Suspension Inquiry Abnormal Short Rides",
      "value": 20330,
      "interactionType": 1
    },
    {
      "label": "Suspension Inquiry Customer App",
      "value": 20331,
      "interactionType": 1
    },
    {
      "label": "Suspension Inquiry Extremely Poor Navigation Unknown To Map",
      "value": 20332,
      "interactionType": 1
    },
    {
      "label": "Suspension Inquiry Car Sold",
      "value": 20333,
      "interactionType": 1
    },
    {
      "label": "Using Red Number Plate",
      "value": 20334,
      "interactionType": 2
    },
    {
      "label": "Suspension Quest Fraud",
      "value": 20335,
      "interactionType": 2
    },
    {
      "label": "Suspension Inquiry Trying To Overcharge",
      "value": 20336,
      "interactionType": 1
    },
    {
      "label": "Suspension Reason Inquiry",
      "value": 20337,
      "interactionType": 1
    },
    {
      "label": "User Unsuspension Request Inquiry",
      "value": 20338,
      "interactionType": 3
    },
    {
      "label": "Suspension Not Getting Unsuspended Inquiry",
      "value": 20339,
      "interactionType": 2
    },
    {
      "label": "Suspension Unsuspension Date Inquiry",
      "value": 20340,
      "interactionType": 1
    }
    ],
    "204": [
      {
        "label": "App Login Error",
        "value": 20401,
        "interactionType": 3
      },
      {
        "label": "Map Issue",
        "value": 20402,
        "interactionType": 3
      },
      {
        "label": "Not Getting Otp / Otp Code Issue",
        "value": 20403,
        "interactionType": 3
      },
      {
        "label": "Ride Booking Not Getting Ride",
        "value": 20404,
        "interactionType": 4
      },
      {
        "label": "App Related Query App Error",
        "value": 20405,
        "interactionType": 3
      },
      {
        "label": "Pathao App Notification Comms Related Query",
        "value": 20406,
        "interactionType": 1
      }
    ],
    "205": [
      {
        "label": "Merchandise Queries Restaurant Bag Unavailable",
        "value": 20501,
        "interactionType": 1
      },
      {
        "label": "Distribution Bag Exchange",
        "value": 20502,
        "interactionType": 3
      },
      {
        "label": "Distribution Bill Pad",
        "value": 20503,
        "interactionType": 3
      },
      {
        "label": "Bag Exchange Inquiry",
        "value": 20504,
        "interactionType": 3
      }
    ],
    "206": [
      {
        "label": "Branding Not Getting Paid Complaint",
        "value": 20601,
        "interactionType": 2
      },
      {
        "label": "Branding Contract Renewal Request",
        "value": 20602,
        "interactionType": 3
      },
      {
        "label": "Brand Promotion Promotion Request",
        "value": 20603,
        "interactionType": 3
      },
      {
        "label": "Inquiry Branding",
        "value": 20604,
        "interactionType": 1
      }
    ],
    "207": [
      {
        "label": "Leave Emergency",
        "value": 20701,
        "interactionType": 3
      },
      {
        "label": "Leave Day Off",
        "value": 20702,
        "interactionType": 3
      },
      {
        "label": "Leave Sick",
        "value": 20703,
        "interactionType": 3
      },
      {
        "label": "Leave Vehicle Issue",
        "value": 20704,
        "interactionType": 3
      },
      {
        "label": "Leave Device Issue",
        "value": 20705,
        "interactionType": 3
      },
      {
        "label": "Break Shift Change",
        "value": 20706,
        "interactionType": 3
      },
      {
        "label": "Break Late Login Inquiry",
        "value": 20707,
        "interactionType": 1
      },
      {
        "label": "Break Short",
        "value": 20708,
        "interactionType": 3
      },
      {
        "label": "Break Lunch",
        "value": 20709,
        "interactionType": 3
      },
      {
        "label": "Break Emergency",
        "value": 20710,
        "interactionType": 3
      },
      {
        "label": "Break Device Issue",
        "value": 20711,
        "interactionType": 3
      }
    ],
    "208": [
      {
        "label": "Ktm Dashain Campaign Details",
        "value": 20801,
        "interactionType": 1
      },
      {
        "label": "Food Campaign Scratch Card Queries",
        "value": 20802,
        "interactionType": 1
      },
      {
        "label": "Pathao App Notification New Campaign Inquiry",
        "value": 20803,
        "interactionType": 1
      }
    ],
    "209": [
      {
        "label": "Cart Update Add Food Item",
        "value": 20901,
        "interactionType": 3
      },
      {
        "label": "Cart Update Remove Food Item",
        "value": 20902,
        "interactionType": 3
      },{
        "label": "Cart Update Food Item Change",
        "value": 20903,
        "interactionType": 3
      },{
        "label": "Cart Update Order Details",
        "value": 20904,
        "interactionType": 1
      },{
        "label": "Order Confirmation Cart",
        "value": 20905,
        "interactionType": 1
      },{
        "label": "Order Confirmation Amount",
        "value": 20906,
        "interactionType": 1
      },{
        "label": "Order Confirmation Unreachable Foodman",
        "value": 20907,
        "interactionType": 2
      },{
        "label": "Cart Update Hand Over",
        "value": 20908,
        "interactionType": 3
      },{
        "label": "Cart Update Change Food Price",
        "value": 20909,
        "interactionType": 3
      },{
        "label": "Cart Update Amount Conformation",
        "value": 209010,
        "interactionType": 1
      },{
        "label": "Cart Update Amount Inquiry",
        "value": 209011,
        "interactionType": 1
      },{
        "label": "Cart Update Price Change",
        "value": 209012,
        "interactionType": 3
      },{
        "label": "Menu Update Change",
        "value": 209013,
        "interactionType": 3
      },{
        "label": "Menu Update Change Food Price",
        "value": 209014,
        "interactionType": 3
      },
    ],
    "210": [
      { "label": "Kathmandu To Chitwan", "value": 21001, "interactionType": 1 }, 
      { "label": "Kathmandu To Pokhara", "value": 21002, "interactionType": 1 }, 
      { "label": "Kathmandu To Hetauda", "value": 21003, "interactionType": 1 }, 
      { "label": "Kathmandu To Biratnagar", "value": 21004, "interactionType": 1 }, 
      { "label": "Kathmandu To Nepalgunj", "value": 21005, "interactionType": 1 }, 
      { "label": "Kathmandu To Butwal", "value": 21006, "interactionType": 1 }, 
      { "label": "Kathmandu To Janakpur", "value": 21007, "interactionType": 1 }, 
      { "label": "Chitwan To Kathmandu", "value": 21008, "interactionType": 1 }, 
      { "label": "Chitwan To Pokhara", "value": 21009, "interactionType": 1 }, 
      { "label": "Chitwan To Hetauda", "value": 21010, "interactionType": 1 }, 
      { "label": "Chitwan To Biratnagar", "value": 21011, "interactionType": 1 }, 
      { "label": "Chitwan To Nepalgunj", "value": 21012, "interactionType": 1 }, 
      { "label": "Chitwan To Butwal", "value": 21013, "interactionType": 1 }, 
      { "label": "Chitwan To Janakpur", "value": 21014, "interactionType": 1 }, 
      { "label": "Pokhara To Kathmandu", "value": 21015, "interactionType": 1 }, 
      { "label": "Pokhara To Chitwan", "value": 21016, "interactionType": 1 }, 
      { "label": "Pokhara To Hetauda", "value": 21017, "interactionType": 1 }, 
      { "label": "Pokhara To Biratnagar", "value": 21018, "interactionType": 1 }, 
      { "label": "Pokhara To Nepalgunj", "value": 21019, "interactionType": 1 }, 
      { "label": "Pokhara To Butwal", "value": 21020, "interactionType": 1 }, 
      { "label": "Pokhara To Janakpur", "value": 21021, "interactionType": 1 }, 
      { "label": "Hetauda To Kathmandu", "value": 21022, "interactionType": 1 }, 
      { "label": "Hetauda To Chitwan", "value": 21023, "interactionType": 1 }, 
      { "label": "Hetauda To Pokhara", "value": 21024, "interactionType": 1 }, 
      { "label": "Hetauda To Biratnagar", "value": 21025, "interactionType": 1 }, 
      { "label": "Hetauda To Nepalgunj", "value": 21026, "interactionType": 1 }, 
      { "label": "Hetauda To Butwal", "value": 21027, "interactionType": 1 }, 
      { "label": "Hetauda To Janakpur", "value": 21028, "interactionType": 1 }, 
      { "label": "Biratnagar To Kathmandu", "value": 21029, "interactionType": 1 }, 
      { "label": "Biratnagar To Chitwan", "value": 21030, "interactionType": 1 }, 
      { "label": "Biratnagar To Pokhara", "value": 21031, "interactionType": 1 }, 
      { "label": "Biratnagar To Hetauda", "value": 21032, "interactionType": 1 }, 
      { "label": "Biratnagar To Nepalgunj", "value": 21033, "interactionType": 1 }, 
      { "label": "Biratnagar To Butwal", "value": 21034, "interactionType": 1 }, 
      { "label": "Biratnagar To Janakpur", "value": 21035, "interactionType": 1 }, 
      { "label": "Nepalgunj To Kathmandu", "value": 21036, "interactionType": 1 }, 
      { "label": "Nepalgunj To Chitwan", "value": 21037, "interactionType": 1 }, 
      { "label": "Nepalgunj To Pokhara", "value": 21038, "interactionType": 1 }, 
      { "label": "Nepalgunj To Hetauda", "value": 21039, "interactionType": 1 }, 
      { "label": "Nepalgunj To Biratnagar", "value": 21040, "interactionType": 1 }, 
      { "label": "Nepalgunj To Butwal", "value": 21041, "interactionType": 1 }, 
      { "label": "Nepalgunj To Janakpur", "value": 21042, "interactionType": 1 }, 
      { "label": "Butwal To Kathmandu", "value": 21043, "interactionType": 1 }, 
      { "label": "Butwal To Chitwan", "value": 21044, "interactionType": 1 }, 
      { "label": "Butwal To Pokhara", "value": 21045, "interactionType": 1 }, 
      { "label": "Butwal To Hetauda", "value": 21046, "interactionType": 1 }, 
      { "label": "Butwal To Biratnagar", "value": 21047, "interactionType": 1 }, 
      { "label": "Butwal To Nepalgunj", "value": 21048, "interactionType": 1 }, 
      { "label": "Butwal To Janakpur", "value": 21049, "interactionType": 1 }, 
      { "label": "Janakpur To Kathmandu", "value": 21050, "interactionType": 1 }, 
      { "label": "Janakpur To Chitwan", "value": 21051, "interactionType": 1 }, 
      { "label": "Janakpur To Pokhara", "value": 21052, "interactionType": 1 }, 
      { "label": "Janakpur To Hetauda", "value": 21053, "interactionType": 1 }, 
      { "label": "Janakpur To Biratnagar", "value": 21054, "interactionType": 1 }, 
      { "label": "Janakpur To Nepalgunj", "value": 21055, "interactionType": 1 }, 
      { "label": "Janakpur To Butwal", "value": 21056, "interactionType": 1 }
    ],
    "211": [
      {
        "label": "Complaint Misbehaviour",
        "value": 21101,
        "interactionType": 2
      },{
        "label": "Complaint Item Missing",
        "value": 21102,
        "interactionType": 2
      },{
        "label": "Complaint Customer Didn't Pay Fare",
        "value": 21103,
        "interactionType": 2
      },{
        "label": "Complaint Multiple Destination Fare",
        "value": 21104,
        "interactionType": 2
      },{
        "label": "Complaint Refused Pickup",
        "value": 21105,
        "interactionType": 2
      },{
        "label": "Flagged Wrong Location",
        "value": 21106,
        "interactionType": 2
      },{
        "label": "Complaint Different Vehicle",
        "value": 21107,
        "interactionType": 2
      },{
        "label": "Complaint Harassment",
        "value": 21108,
        "interactionType": 2
      },{
        "label": "Complain Poor Behaviour",
        "value": 21109,
        "interactionType": 2
      },{
        "label": "Complaint Restaurant Staff Rude Behaviour",
        "value": 211010,
        "interactionType": 2
      },{
        "label": "Report Issue Unprofessional Behaviour Of Restaurant",
        "value": 211011,
        "interactionType": 2
      },{
        "label": "Complaint Customer Rude Behaviour",
        "value": 211012,
        "interactionType": 2
      }
    ],
    "212": [
      {
        "label": "Completion Rate Inquiry Skip Order",
        "value": 21201,
        "interactionType": 1
      },
      {
        "label": "Completion Rate Inquiry App Issue",
        "value": 21202,
        "interactionType": 1
      },
      {
        "label": "Completion Rate Inquiry Phone Problem",
        "value": 21203,
        "interactionType": 1
      }
    ],
    "213": [
      {
        "label": "Request to change Driver Type",
        "value": 21301,
        "interactionType": 3
      }
    ],
    "214": [
      {
        "label": "Due Reimburse Request",
        "value": 21401,
        "interactionType": 3
      }
    ],
    "215": [
      {
        "label": "E Support Not Getting Request / Not Getting Ride",
        "value": 21501,
        "interactionType": 2
      },{
        "label": "E Support Reset the Account",
        "value": 21502,
        "interactionType": 3
      },{
        "label": "E Support Notification Problem",
        "value": 21503,
        "interactionType": 3
      },{
        "label": "E Support Map Issue",
        "value": 21504,
        "interactionType": 3
      },{
        "label": "Inquiry Pathao Drive App",
        "value": 21505,
        "interactionType": 1
      },
      {
        "label": "E Support App Loading",
        "value": 21506,
        "interactionType": 3
      }
    ],
    "216": [
      { "label": "Foodman Unreachable", "value": 21601, "interactionType": 2 },
      { "label": "Unavailablity Of Foodman", "value": 21602, "interactionType": 2 },
      { "label": "Er Food Cancellation Delay In Preparing Time", "value": 21603, "interactionType": 3 },
      { "label": "Er Food Cancellation Delay In Delivering Time", "value": 21604, "interactionType": 3 },
      { "label": "Er Food Cancellation Customer Asked For Cancellation", "value": 21605, "interactionType": 3 },
      { "label": "Er Food Cancellation Food Not Available", "value": 21606, "interactionType": 3 },
      { "label": "Er Food Cancellation Wrong Location", "value": 21607, "interactionType": 3 },
      { "label": "Er Food Cancellation Restaurant Closed", "value": 21608, "interactionType": 3 },
      { "label": "Er Food Cancellation Food Person Requested", "value": 21609, "interactionType": 3 },
      { "label": "Er Food Cancellation Food Person Rude Behaviour", "value": 216010, "interactionType": 2 },
      { "label": "Er Food Cancellation Need Food From Different Restaurant", "value": 216011, "interactionType": 3 },
      { "label": "Er Food Cancellation Not Applied Promo Code", "value": 216012, "interactionType": 2 },
      { "label": "Er Food Cancellation Order From Other Sources", "value": 216013, "interactionType": 3 },
      { "label": "Er Food Cancellation Pre Order Booking", "value": 216014, "interactionType": 3 },
      { "label": "Er Food Cancellation Customer Phone Unreachable", "value": 216015, "interactionType": 3 },
      { "label": "Er Food Cancellation Mistakenly Order", "value": 216016, "interactionType": 3 },
      { "label": "Er Food Cancellation Vehicle Issue", "value": 216017, "interactionType": 3 },
      { "label": "Er Food Cancellation Device Issue", "value": 216018, "interactionType": 3 },
      { "label": "Er Food Cancellation Long Distance Order", "value": 216019, "interactionType": 3 },
      { "label": "Er Food Cancellation Emergency Cancellation Request", "value": 216020, "interactionType": 3 },
      { "label": "Er Food Cancellation Delivering Location Change", "value": 216021, "interactionType": 3 },
      { "label": "Er Food Cancellation Due To High Delivery Charge", "value": 216022, "interactionType": 4 },
      { "label": "Customer Canceled Digital Wallet Issue", "value": 216023, "interactionType": 2 },
      { "label": "Er Food Cancellation No Digital Payment Method", "value": 216024, "interactionType": 4 },
      { "label": "Complaint Pathao Hero Cancelled Order", "value": 216025, "interactionType": 2 },
      { "label": "Er Food Cancellation Fraud Customers", "value": 216026, "interactionType": 2 },
    ],
    "217": [
      { "label": "Commission Complaint", "value": 21701, "interactionType": 2 },
      { "label": "Surge Price Per Km Inquiry", "value": 21702, "interactionType": 1 },
      { "label": "Complaint Dynamic Pick Up Charge Feedback/Complaints", "value": 21703, "interactionType": 2 },
      { "label": "Fare All Day Charge", "value": 21704, "interactionType": 1 },
      { "label": "Fare Price Per K/M", "value": 21705, "interactionType": 1 },
      { "label": "Surge Price Per K/M", "value": 21706, "interactionType": 1 },
      { "label": "Fare Inquiry", "value": 21707, "interactionType": 1 },
      { "label": "Ride Fare Increment", "value": 21708, "interactionType": 1 }
    ],
    "218": [
      { "label": "Feedback For Pathao", "value": 21801, "interactionType": 4 },
      { "label": "Feedback For Driver Application", "value": 21802, "interactionType": 4 },
      { "label": "Suggestion For Driver Application", "value": 21803, "interactionType": 1 },
      { "label": "Feedback/Suggestion Other Digital Payment", "value": 21804, "interactionType": 1 },
      { "label": "Feedback/Suggestion Advance Request", "value": 21805, "interactionType": 1 },
      { "label": "Feedback/Suggestion Parking Area Unavailable", "value": 21806, "interactionType": 4 }
    ],
    "219": [
      {
        "label": "Call From Pathao Follow Up Call Customer",
        "value": 21901,
        "interactionType": 1
      },
      {
        "label": "Call From Pathao Re Order Follow Up Call",
        "value": 21902,
        "interactionType": 1
      },
      {
        "label": "Call From Pathao Follow Up Call Restaurant",
        "value": 21903,
        "interactionType": 1
      },
      {
        "label": "Call From Pathao Follow Up Call Food Person",
        "value": 21904,
        "interactionType": 1
      }
    ],
    "220": [
      { "label": "Complaint Delay In Delivery", "value": 22001, "interactionType": 2 },
      { "label": "Complaint Bad Food Quality", "value": 22002, "interactionType": 2 },
      { "label": "Report Issue Bad Food Quality", "value": 22003, "interactionType": 2 },
      { "label": "Complaint Food Items Missing", "value": 22004, "interactionType": 2 },
      { "label": "Complaint Wrong Item Delivered", "value": 22005, "interactionType": 2 },
      { "label": "Complaint Different Food Items", "value": 22006, "interactionType": 2 },
      { "label": "Complaint Packaging Problem", "value": 22007, "interactionType": 2 },
      { "label": "Complaint Foodman Rude Behaviour", "value": 22008, "interactionType": 2 },
      { "label": "Complaint Unavailablity Of Food Person", "value": 22009, "interactionType": 2 },
      { "label": "Phone Number / Supervisor Number Request", "value": 22010, "interactionType": 3 }
    ],
    "221": [
      { "label": "Total Trip Earning", "value": 22101, "interactionType": 1 },
      { "label": "Rating Inquiry", "value": 22102, "interactionType": 1 },
      { "label": "Details Information Rider", "value": 22103, "interactionType": 1 },
      { "label": "Application Availability Inquiry Ios", "value": 22104, "interactionType": 1 },
      { "label": "Long Distance Pickup Inquiry", "value": 22105, "interactionType": 1 },
      { "label": "Multiple Destination Inquiry", "value": 22106, "interactionType": 1 },
      { "label": "Preferred Destination Inquiry", "value": 22107, "interactionType": 1 },
      { "label": "Long Destination Request Complaint", "value": 22108, "interactionType": 2 },
      { "label": "Geo Fence Availability", "value": 22109, "interactionType": 1 },
      { "label": "Rental Service Interested", "value": 22110, "interactionType": 1 },
      { "label": "Inquiry Forward Dispatch", "value": 22111, "interactionType": 1 },
      { "label": "Esupport How To Use App", "value": 22112, "interactionType": 1 },
      { "label": "Report Issue How To Report", "value": 22113, "interactionType": 1 },
      { "label": "Flagged Picked Wrong Customer", "value": 22114, "interactionType": 2 },
      { "label": "Office Open Time", "value": 22115, "interactionType": 1 },
      { "label": "Toll Free Number", "value": 22116, "interactionType": 1 },
      { "label": "Pathao Mail Id", "value": 22117, "interactionType": 1 },
      { "label": "Company Information Inquiry", "value": 22118, "interactionType": 1 },
      { "label": "Car Plus Inquiry", "value": 22119, "interactionType": 1 },
      { "label": "Leader Board Related Inquiry", "value": 22120, "interactionType": 1 },
      { "label": "Service Expansion Inquiry", "value": 22121, "interactionType": 1 },
      { "label": "Suggestion For Customer Application", "value": 22122, "interactionType": 1 },
      { "label": "General Inquiries Parking Fee", "value": 22123, "interactionType": 1 },
      { "label": "General Inquiries Mail", "value": 22124, "interactionType": 1 },
      { "label": "General Inquiries Refill", "value": 22125, "interactionType": 1 },
      { "label": "About Company General Inquiries", "value": 22126, "interactionType": 1 },
      { "label": "General Inquiries Customer Campaign", "value": 22127, "interactionType": 1 },
      { "label": "Operation Hour Query", "value": 22128, "interactionType": 1 },
      { "label": "Inquiry Strike Update Service Time", "value": 22129, "interactionType": 1 },
      { "label": "Ph Online Status Inquiry", "value": 22130, "interactionType": 1 },
      { "label": "About Information Company General Inquiries", "value": 22131, "interactionType": 1 }
    ],
    "222": [
      { "label": "Inquiry Pokhara Ride Service", "value": 22201, "interactionType": 1 },
      { "label": "Complaint Pokhara Ride Service", "value": 22202, "interactionType": 2 },
      { "label": "Geo Fence Update Inquiry", "value": 22203, "interactionType": 1 },
      { "label": "Geo Fence Location Addition Request", "value": 22204, "interactionType": 3 },
      { "label": "Geo Fence Availability Confirmation", "value": 22205, "interactionType": 1 },
      { "label": "Geo Fence Unavailability Complaint", "value": 22206, "interactionType": 2 },
      { "label": "Geo Fence Order", "value": 22207, "interactionType": 1 }
    ],
    "223": [
      {
        "label": "Complain Person Missing",
        "value": 22301,
        "interactionType": 2
      },
      {
        "label": "Lutpat Case",
        "value": 22302,
        "interactionType": 2
      }
    ],
    "224": [
      { "label": "Accident Insurance Claim", "value": 22401, "interactionType": 3 },
      { "label": "Accident Insurance Intimation", "value": 22402, "interactionType": 3 },
      { "label": "Accident Insurance Info / Required Documents", "value": 22403, "interactionType": 1 },
      { "label": "Accidental Query", "value": 22404, "interactionType": 1 },
      { "label": "Accident Report Update", "value": 22405, "interactionType": 3 }
    ],
    "225": [
      {
        "label": "Office Location Wis Visit",
        "value": 22501,
        "interactionType": 1
      },
      {
        "label": "Office Location New Joinee",
        "value": 22502,
        "interactionType": 1
      },
      {
        "label": "Office Location Chitwan",
        "value": 22503,
        "interactionType": 1
      }
    ],
    "226": [
      {
        "label": "Navigation Issue Customer Location",
        "value": 22601,
        "interactionType": 3
      },
      {
        "label": "Navigation Issue Restaurant Location",
        "value": 22602,
        "interactionType": 3
      }
    ],
    "227": [
      { "label": "New Registration Appointment", "value": 22701, "interactionType": 3 },
      { "label": "New Registration Office Location", "value": 22702, "interactionType": 1 },
      { "label": "New Training Inquiry", "value": 22703, "interactionType": 1 },
      { "label": "Training Queries", "value": 22704, "interactionType": 1 },
      { "label": "New Registration Private Car Registration Inquiry", "value": 22705, "interactionType": 1 },
      { "label": "New Registration Want Retraining", "value": 22706, "interactionType": 3 },
      { "label": "New Registration Campaign Details", "value": 22707, "interactionType": 1 },
      { "label": "New Registration Campaign Date And Time", "value": 22708, "interactionType": 1 },
      { "label": "New Registration How To Join", "value": 22709, "interactionType": 1 },
      { "label": "New Registration Owner Change", "value": 22710, "interactionType": 3 },
      { "label": "New Registration Ph", "value": 22711, "interactionType": 1 },
      { "label": "New Registration Registration Charge", "value": 22712, "interactionType": 1 },
      { "label": "New Registration Job Vacancy", "value": 22713, "interactionType": 1 },
      { "label": "New Registration Walker", "value": 22714, "interactionType": 1 }
    ],
    "228": [
      { "label": "Previous Order Issue", "value": 22801, "interactionType": 2 },
      { "label": "Order Placement Inquiry", "value": 22802, "interactionType": 1 },
      { "label": "Order Confirmation Restaurant Phone Unreachable", "value": 22803, "interactionType": 2 },
      { "label": "Order Confirmation Customer Phone Unreachable", "value": 22804, "interactionType": 2 },
      { "label": "Order Mistakenly Delivered", "value": 22805, "interactionType": 2 },
      { "label": "Order Takeover Pathao Hero Vehicle Issue", "value": 22806, "interactionType": 3 },
      { "label": "Order Takeover Pathao Hero Device Issue", "value": 22807, "interactionType": 3 },
      { "label": "Ph Batch Order Inquiry", "value": 22808, "interactionType": 1 },
      { "label": "Order Confirmation Restaurant Closed", "value": 22809, "interactionType": 2 },
      { "label": "Order Confirmation Distance Inquiry", "value": 22810, "interactionType": 1 },
      { "label": "Forward Dispatch Inquiry", "value": 22811, "interactionType": 1 }
    ],
    "229": [
      { "label": "Parcel Inquiry Parcel Service", "value": 22901, "interactionType": 1 },
      { "label": "Parcel Customer Unreachable", "value": 22902, "interactionType": 2 },
      { "label": "Parcel Execution End Trip", "value": 22903, "interactionType": 3 },
      { "label": "Delivery Delay", "value": 22904, "interactionType": 2 },
      { "label": "Lost Item", "value": 22905, "interactionType": 2 },
      { "label": "Parcel Payment Issue", "value": 22906, "interactionType": 2 },
      { "label": "Parcel Delivery Inquiry", "value": 22907, "interactionType": 1 },
      { "label": "Parcel Complain Rider Unreachable", "value": 22908, "interactionType": 2 },
      { "label": "Parcel Service Inquiry", "value": 22909, "interactionType": 1 },
      { "label": "Parcel Complain Overcharge", "value": 22910, "interactionType": 2 },
      { "label": "Parcel Charge Inquiry", "value": 22911, "interactionType": 1 },
      { "label": "Parcel Service Related", "value": 22912, "interactionType": 1 }
    ],
    "230": [
      { "label": "Customer Canceled Wrong Restaurant Selected", "value": 23001, "interactionType": 1 },
      { "label": "Customer Canceled Wrong Delivery Address", "value": 23002, "interactionType": 1 },
      { "label": "Customer Canceled Change Of Mind", "value": 23003, "interactionType": 1 },
      { "label": "Customer Canceled Restaurant Prep Delay", "value": 23004, "interactionType": 2 },
      { "label": "Customer Canceled Mistakenly Ordered", "value": 23005, "interactionType": 1 },
      { "label": "Parcel Request Cancellation User Changed Mind", "value": 23006, "interactionType": 3 },
      { "label": "Parcel Complain Canceled Ride", "value": 23007, "interactionType": 2 },
      { "label": "Customer Canceled Pathao Hero Unreachable", "value": 23008, "interactionType": 2 },
      { "label": "Ride Cancellation Unreachable Rider", "value": 23009, "interactionType": 2 },
      { "label": "Customer Canceled Personal Emergency Work", "value": 23010, "interactionType": 1 },
      { "label": "Customer Canceled Customer Not At Home", "value": 23011, "interactionType": 1 },
      { "label": "Pathao Hero Requested Customer Requested Cancellation", "value": 23012, "interactionType": 1 },
      { "label": "Pathao Hero Canceled Personal/Emergency Reason", "value": 23013, "interactionType": 1 },
      { "label": "Pathao Hero Canceled Vehicle Issue", "value": 23014, "interactionType": 1 },
      { "label": "Pathao Hero Canceled Device Issue", "value": 23015, "interactionType": 1 },
      { "label": "Pathao Hero Canceled Duty Time Off", "value": 23016, "interactionType": 1 },
      { "label": "Pathao Hero Canceled Long Distance Order", "value": 23017, "interactionType": 1 }
    ],
    "231": [
      {
        "label": "Pathao Benefit Program Details",
        "value": 23101,
        "interactionType": 1
      },
      {
        "label": "Tier Details Inquiry",
        "value": 23102,
        "interactionType": 1
      },
    ],
    "232": [
      {
        "label": "Earning / Verification of Association Letterhead",
        "value": 23201,
        "interactionType": 3
      }
    ],
    "233": [
      {
        "label": "Inquiry Pathao Points",
        "value": 23301,
        "interactionType": 1
      }
    ],
    "234": [
      { "label": "Fine Payment Number Inquiry", "value": 23401, "interactionType": 1 },
      { "label": "Non-Fine Amount Refund Inquiry", "value": 23402, "interactionType": 1 },
      { "label": "Inquiry security deposit", "value": 23403, "interactionType": 1 },
      { "label": "Payment Method Inquiry", "value": 23404, "interactionType": 1 },
      { "label": "Payment Issue", "value": 23405, "interactionType": 2 },
      { "label": "Payment To Wrong Number", "value": 23406, "interactionType": 1 },
      { "label": "Fine Payment Number", "value": 23407, "interactionType": 1 },
      { "label": "Complaint Payment Issue", "value": 23408, "interactionType": 2 },
      { "label": "No Digital Payment Method", "value": 23409, "interactionType": 4 },
      { "label": "Delivery Charge Complaint", "value": 23410, "interactionType": 2 },
      { "label": "Delivery Charge Price Per Delivery", "value": 23411, "interactionType": 1 },
      { "label": "Complaint Customer Didn't Pay", "value": 23412, "interactionType": 2 },
      { "label": "Billing Payment Transaction Inquiry", "value": 23413, "interactionType": 1 },
      { "label": "Billing Payment Account Sections Number", "value": 23414, "interactionType": 1 },
      { "label": "Billing Payment Delay Reason", "value": 23415, "interactionType": 1 },
      { "label": "Payment Quieres Account Sections Number", "value": 23416, "interactionType": 1 },
      { "label": "Complaint Customer Online Payment Failed", "value": 23417, "interactionType": 2 }
    ],
    "235": [
      { "label": "Due Inquiry", "value": 23501, "interactionType": 1 },
      { "label": "Kyc Verification Inquiry", "value": 23502, "interactionType": 1 },
      { "label": "Balance Load Process", "value": 23503, "interactionType": 1 },
      { "label": "How To Pay Due Amount", "value": 23504, "interactionType": 1 },
      { "label": "About Digital Wallet", "value": 23505, "interactionType": 1 },
      { "label": "Sewa Kendra Inquiry", "value": 23506, "interactionType": 1 },
      { "label": "Amount Refund Inquiry", "value": 23507, "interactionType": 1 },
      { "label": "Number Update Request", "value": 23508, "interactionType": 3 }
    ],
    "236": [
      { "label": "Personal Account Information Password Change", "value": 23601, "interactionType": 3 },
      { "label": "Inquiry Details Information Captain", "value": 23602, "interactionType": 1 },
      { "label": "Inquiry Tier Categories Determined", "value": 23603, "interactionType": 1 },
      { "label": "Personal Account Information Change Order Taking Number", "value": 23604, "interactionType": 3 },
      { "label": "Personal Account Information Ac Number Change", "value": 23605, "interactionType": 3 },
      { "label": "Personal Account Information Doc Change", "value": 23606, "interactionType": 3 },
      { "label": "Personal Account Information Profile Change", "value": 23607, "interactionType": 3 }
    ],
    "237": [
      { "label": "No Raincoat", "value": 23701, "interactionType": 2 },
      { "label": "Resignation Ph", "value": 23702, "interactionType": 3 },
      { "label": "Resignation Will Resign", "value": 23703, "interactionType": 3 },
      { "label": "Payment Queries Bill Pad Inquiry", "value": 23704, "interactionType": 1 },
      { "label": "Payment Queries Salary Issue", "value": 23705, "interactionType": 2 },
      { "label": "Payment Queries Bag Problem", "value": 23706, "interactionType": 2 },
      { "label": "Ph Bag Exchange", "value": 23707, "interactionType": 3 },
      { "label": "Ph Bag Problem", "value": 23708, "interactionType": 2 },
      { "label": "Ph Rejoin", "value": 23709, "interactionType": 3 },
      { "label": "Ph Merchandise Jacket/Light Inquiry", "value": 23710, "interactionType": 1 },
      { "label": "Ph Refer And Earn Inquiry", "value": 23711, "interactionType": 1 },
      { "label": "Ph Tip Inquiry", "value": 23712, "interactionType": 1 }
    ],
    "238": [
      { "label": "Quest Criteria", "value": 23801, "interactionType": 1 },
      { "label": "Quest Hour Lock", "value": 23802, "interactionType": 1 },
      { "label": "Quest Inquiry Order Take Over", "value": 23803, "interactionType": 1 },
      { "label": "Quest Inquiry Bonus", "value": 23804, "interactionType": 1 },
      { "label": "Quest Inquiry Long Distance Order", "value": 23805, "interactionType": 1 }
    ],
    "239": [
      { "label": "Quest Not Getting / Amount Query", "value": 23901, "interactionType": 1 },
      { "label": "Campaign Document Inquiry", "value": 23902, "interactionType": 1 },
      { "label": "Referral Code Inquiry / How To Apply", "value": 23903, "interactionType": 1 },
      { "label": "Promo Code Inquiry", "value": 23904, "interactionType": 1 },
      { "label": "Promo Code Unable To Apply", "value": 23905, "interactionType": 2 },
      { "label": "Promo Code How To Apply", "value": 23906, "interactionType": 1 },
      { "label": "Complaint Discount Amount", "value": 23907, "interactionType": 2 },
      { "label": "Promo Code Amount Inquiry", "value": 23908, "interactionType": 1 },
      { "label": "Promo Code Discount Amount", "value": 23909, "interactionType": 1 },
      { "label": "Referral Code Inquiry", "value": 23910, "interactionType": 1 }
    ],
    "240": [
      {
        "label": "Rental Ride Cancellation Inquiry",
        "value": 24001,
        "interactionType": 1
      }
    ],
    "241": [
      { "label": "Rental Fare Inquiry", "value": 24101, "interactionType": 1 },
      { "label": "Rental New Training Inquiry", "value": 24102, "interactionType": 1 },
      { "label": "Rental Fare Complaint", "value": 24103, "interactionType": 2 },
      { "label": "Rental Commission Inquiry", "value": 24104, "interactionType": 1 },
      { "label": "Rental Request Off", "value": 24105, "interactionType": 3 }
    ],
    "242": [
      {
        "label": "Dashboard Queries",
        "value": 24201,
        "interactionType": 1
      },
      {
        "label": "Open Visible In App",
        "value": 24202,
        "interactionType": 1
      },
      {
        "label": "Close Unvissible In App",
        "value": 24203,
        "interactionType": 1
      }
    ],
    "243": [
      { "label": "Restaurant Offer Inquiry", "value": 24301, "interactionType": 1 },
      { "label": "Complain Delay In Preparing Time", "value": 24302, "interactionType": 2 },
      { "label": "Complaint Delay In Picking Up Food", "value": 24303, "interactionType": 2 },
      { "label": "Complaint Wrong Item Pick Up", "value": 24304, "interactionType": 2 },
      { "label": "Complain About Low Food Quantity", "value": 24305, "interactionType": 2 },
      { "label": "Complaint Delivery Charge Is High", "value": 24306, "interactionType": 2 },
      { "label": "Complaint Mapping Problem", "value": 24307, "interactionType": 2 },
      { "label": "Complaint Restaurant Phone Unreachable", "value": 24308, "interactionType": 2 },
      { "label": "Complaint Customer Denied To Received Food", "value": 24309, "interactionType": 2 }
    ],
    "244": [
      { "label": "Mistake Call For Ride Query", "value": 24401, "interactionType": 1 },
      { "label": "Mistake Ride Cancellation Call", "value": 24402, "interactionType": 1 },
      { "label": "Start And End Fare Calculate Issue / Extra Fare Issue", "value": 24403, "interactionType": 2 },
      { "label": "Report Issue Start And End / Flagged Wrong Location", "value": 24404, "interactionType": 1 },
      { "label": "Fare Fare Complaint / Fare Inquiry", "value": 24405, "interactionType": 2 },
      { "label": "Dynamic Pick Up Charge Fare Issue", "value": 24406, "interactionType": 2 },
      { "label": "Surge Pickup Surge Inquiry / Complaint", "value": 24407, "interactionType": 2 },
      { "label": "Complaint Refused To Pickup", "value": 24408, "interactionType": 2 },
      { "label": "Suspension Refused To Arrive At Pickup/Drop", "value": 24409, "interactionType": 2 }
    ],
    "245": [
      { "label": "Ride Booking Booking Request Through Cc", "value": 24501, "interactionType": 3 },
      { "label": "Ride Booking Pre Booking", "value": 24502, "interactionType": 1 },
      { "label": "Ride Booking How To Book Ride", "value": 24503, "interactionType": 1 },
      { "label": "Ride Booking Booking Charge", "value": 24504, "interactionType": 1 },
      { "label": "Ride Request Multi Ride Dispatch", "value": 24505, "interactionType": 1 },
      { "label": "Ride Booking How To Book", "value": 24506, "interactionType": 1 },
      { "label": "Booking How To Book The Ride", "value": 24507, "interactionType": 1 },
      { "label": "Booking How To Download App", "value": 24508, "interactionType": 1 },
      { "label": "Booking How To Use Pathao App", "value": 24509, "interactionType": 1 },
      { "label": "Ride Booking Through Office", "value": 24510, "interactionType": 3 },
      { "label": "Ride Booking All Day Charge", "value": 24511, "interactionType": 1 },
      { "label": "Ride Ride Related Query", "value": 24512, "interactionType": 1 },
      { "label": "Booking Need To Send Food Person", "value": 24513, "interactionType": 3 },
      { "label": "How To Take Online Ride", "value": 24514, "interactionType": 1 },
      { "label": "Order / Booking Related", "value": 24515, "interactionType": 1 },
      { "label": "Booking How To Order Food", "value": 24516, "interactionType": 1 },
      { "label": "Booking Order Booking Through Cc", "value": 24517, "interactionType": 3 },
      { "label": "Booking Delivery Time", "value": 24518, "interactionType": 1 }
    ],
    "246": [
      {
        "label": "Saver Plans Subscription Inquiry",
        "value": 24601,
        "interactionType": 1
      },
    ],
    "247": [
      {
        "label": "Car Lite Switch Car Plus",
        "value": 24701,
        "interactionType": 3
      },{
        "label": "Car Plus Switch Car Lite",
        "value": 24702,
        "interactionType": 3
      },
    ],
    "248": [
      {
        "label": "Traffic Caught What To Do",
        "value": 24801,
        "interactionType": 1
      },{
        "label": "Traffic Caught Rider Information",
        "value": 24802,
        "interactionType": 1
      },
    ],
    "249": [
      { "label": "Blank Call", "value": 24901, "interactionType": 5 },
      { "label": "Disturbed Conversation", "value": 24902, "interactionType": 5 },
      { "label": "Call Hold", "value": 24903, "interactionType": 5 },
      { "label": "Unwanted Call Different Sources Query", "value": 24904, "interactionType": 5 },
      { "label": "Unwanted Call Blank Call", "value": 24905, "interactionType": 5 },
      { "label": "Unwanted Call Hang Up Call", "value": 24906, "interactionType": 5 }
    ],
    "250": [
      { "label": "Order Created Late", "value": 25001, "interactionType": 2 },
    ],
    "251": [
      { "label": "Call From Pathao Follow Up Call Rider/Captain", "value": 25101, "interactionType": 1 },
    ],
    "252": [
      { "label": "Start & End Same Location Words", "value": 25201, "interactionType": 2 },
    ],
    "253": [
      { "label": "Delivery location mistaken", "value": 25301, "interactionType": 2 },
    ],
    "254": [
      { "label": "ph type change", "value": 25401, "interactionType": 3 },
    ],
    "255": [
      { "label": "About Platform Service", "value": 25501, "interactionType": 1 },
      { "label": "Platform Service Charge related", "value": 25502, "interactionType": 1 },
      { "label": "Eligible Criteria", "value": 25503, "interactionType": 1 },
      { "label": "No Commission Inquiry", "value": 25504, "interactionType": 1 },
    ],
  };

  const INTERACTION_TYPE_OPTIONS = [
    { label: "Query", value: 1 },
    { label: "Complaint", value: 2 },
    { label: "Request", value: 3 },
    { label: "Grievance", value: 4 },
    { label: "Unwanted", value: 5 }
  ];

  const ticket_required = [
    { label: "No", value: 0 },
    { label: "Yes", value: 1 },
  ]

  const fetchNotes = async (contactId) => {
    setNotes([]);
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(
        `${config.apiBaseUrl}/api/v1/reports/${contactId}/notes?limit=5`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await response.json();

      if (result.success) {
        setNotes(result.data);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    }
  };

  useEffect(() => {
    fetchNotes(contactId);
  }, [contactId]);


  function getPlainText(remarks) {
    try {
      const parsedRemarks = JSON.parse(remarks);

      if (parsedRemarks.blocks && Array.isArray(parsedRemarks.blocks)) {
        return parsedRemarks.blocks.map((block) => block.text).join(" ");
      }
    } catch (e) {}

    return remarks;
  }

  const changeContactValue = (e) => {
    const { name, value } = e.target;
    setUpdateContactData({ ...updateContactData, [name]: value });
    setupdateContactformErrors({ ...updateContactformErrors, [name]: "" });
  };

  const validateUpdateContactFields = () => {
    const errors = {};
    // if (!updateContactData?.first_name) {
    //   errors.first_name = "First name is required";
    // }
    if (!updateContactData?.contact_primary) {
      errors.contact_primary = "Contact number is required";
    } if (!updateContactData?.vertical_type) {
      errors.vertical_type = "Vertical type is required";
    } if (!updateContactData?.caller_type) {
      errors.caller_type = "Caller type is required";
    } if (!updateContactData?.interaction_type) {
      errors.interaction_type = "Interaction type is required";
    } if (!updateContactData?.interaction_category) {
      errors.interaction_category = "Interaction Category is required";
    } if (!updateContactData?.interaction_sub_category) {
      errors.interaction_sub_category = "Interaction Sub Category is required";
    } if (!updateContactData?.ticket_required) {
      errors.ticket_required = "Ticket is required";
    }
    // if (!updateContactData?.remarks) {
    //   errors.remarks = "Remarks is required";
    // }
    // if (!updateContactData?.remarksTitle) {
    //   errors.remarksTitle = "Remarks title is required";
    // }
    // if (!updateContactData?.company) {
    //   errors.company = "Company is required";
    // }
    // if (!updateContactData?.state) {
    //   errors.state = "State is required";
    // }
    // if (!updateContactData?.street) {
    //   errors.street = "Street is required";
    // }
    // if (!updateContactData?.city) {
    //   errors.city = "City is required";
    // }
    // if (!updateContactData?.country) {
    //   errors.country = "Country is required";
    // }
    setupdateContactformErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleUpdateContact = async (e, status = false) => {
    if (loading) {
      return;
    }

    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (!validateUpdateContactFields()) {
      return;
    }

    const contactNumberList = [
      {
        value: updateContactData.contact_primary,
        type: "1",
      },
    ];

    const rawCallId = callSid || "";
    const cleanCallId = rawCallId.startsWith("AG_") ? rawCallId.replace(/^AG_/, "") : rawCallId;
        
    const dataToSend = {
      contact_number: contactNumberList,
      registration_number: updateContactData.registration_number,
      name: updateContactData.name,
      dis_id: updateContactData.id,
      vertical_type: updateContactData.vertical_type,
      order_id: updateContactData.order_id,
      caller_type: updateContactData.caller_type,
      interaction_type: updateContactData.interaction_type,
      interaction_category: updateContactData.interaction_category,
      interaction_sub_category: updateContactData.interaction_sub_category,
      note: updateContactData.note,
      ticket_required: updateContactData.ticket_required,
      created_by: user.id,
      call_id: cleanCallId,
      contact_id: contactId,
      parse_id: updateContactData.parse_id,
      city_id: updateContactData.city_id
    };

    // Filter out any keys with value undefined, null, or empty string
    const cleanedData = Object.entries(dataToSend).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        acc[key] = value;
      }
      return acc;
    }, {});

    const token = localStorage.getItem("token");

    setLoading(true);

    try {
      const response = await fetch(
        `${config.apiBaseUrl}/api/v1/contacts/${updateContactData.contact_primary}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(cleanedData),
        }
      );

      const data = await response.json();
      
      if (data.success) {
        toast.success(data.message || "Contact updated successfully");
        // setUpdateContactData({});
        setupdateContactformErrors({});
        fetchNotes(contactId);
        const res = await fetch(
           `${config.apiBaseUrl}/api/v1/reports/${number}/call-disposition?limit=5`,
           {
             headers: {
               Authorization: `Bearer ${token}`,
             },
           }
         );
         const disResult = await res.json();
         if (disResult && disResult.success) {
           setDispositionData(disResult.data); 
           const latestNote = disResult.data[0];
           setUpdateContactData((prevData) => ({
             ...prevData,
             registration_number: latestNote?.registration_number,
             id: latestNote?.dis_id,
           }))
         }
      } else {
        toast.error(data.message || "Failed to updated contact");
      }
    } catch (error) {
      console.error("Error updating contact:", error);
      toast.error("Error updating contact");
    } finally {
      setLoading(false);
      // onClose();
       setTimeout(() => window.close(), 1500);
    }
  };

  const fetchCallStatus = async (campaign_id, call_id) => {
    try {
      //   if (loading) {
      //     return;
      //   }
      if (!isMountedRef.current) return;
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${config.apiBaseUrl}/api/v1/campaigns/${campaign_id}/calls/${call_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.json();
      if (data.success) {
        if (Object.keys(data.data).length === 0) {
          timeoutRef.current = setTimeout(() => {
            if (isMountedRef.current) fetchCallStatus(campaign_id, call_id);
          }, 15000);
        } else {
          setCallStatus(data.data.call_event);
          if (
            data.data.call_event !== "LEAD_CALL_HANGUP" &&
            data.data.call_event !== "AGENT_CALL_HANGUP"
          ) {
            fetchCallStatus(campaign_id, call_id);
          }
        }
      } else {
        toast.error(data.message || "Failed to retrieve call status");
      }
    } catch (error) {
      console.error("Error fetching call status:", error);
      toast.error("Error fetching call status");
    }
  };

  const OPTION_MAP = {
    vertical_type: OPTIONS_VERTICAL_TYPE,
    ticket_required: ticket_required,
    interaction_category: INTERACTION_CATEGORY,
    caller_type: CALLER_TYPE_OPTIONS,
    interaction_type: INTERACTION_TYPE_OPTIONS,
    interaction_sub_category: INTERACTION_SUB_CATEGORIES
  };
  const getLabel = (field, value, parentKey = null) => {
    if (value === null || value === undefined || value === "") return "-";
    const source = OPTION_MAP[field];
    if (!source) return String(value);

    const options = parentKey != null ? source?.[parentKey] : source;

    if (!Array.isArray(options)) return String(value);

    const found = options.find((opt) => Number(opt.value) === Number(value));
    return found ? found.label : String(value);
  };

  const getSubCategoriesByVertical = (verticalType) => {
    if (!verticalType) return [];

    const categories = INTERACTION_CATEGORY[verticalType] || [];

    return categories.flatMap((cat) => {
      const subs = INTERACTION_SUB_CATEGORIES[cat.value] || [];
      return subs.map((sub) => ({
        ...sub,
        interaction_category: cat.value, 
      }));
    });
  };

  return (
    <>
    <Sidebar />
    <ToastContainer style={{ marginTop: "80px" }} />
      {loading && (
        <div className="loader-overlay">
          <FadeLoader
            color="#808080"
            height={10}
            width={3}
            radius={0}
            margin={-5}
          />
        </div>
      )}
      <div
      className="mt-5"
        // className="modal-overlay"
        // style={{
        //   zIndex: 999999,
        //   position: "fixed",
        //   top: 0,
        //   left: 0,
        //   width: "100%",
        //   height: "100%",
        //   backgroundColor: "rgba(0, 0, 0, 0.5)",
        //   overflowY: "auto",
        // }}
      >
        <div className="modal-xl modal-dialog modal-dialog-centered custom-modal-width">
          <div className="modal-content" style={{ backgroundColor: "#fcfcfc" }}>
            <div
              className="modal-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
              }}
            >
              <h5 className="modal-title" style={{ margin: 0 }}>
                Contact Details
              </h5>
              {/* <button
                type="button"
                className="btn-close"
                onClick={onClose}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "1.5rem",
                  lineHeight: "1",
                }}
              >
                &times;
              </button> */}
            </div>
            <div className="modal-body">
              <div className="lyt_box mt-4">
                <div className="row g-4">
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="block-widget">
                      <h6>Form</h6>
                      <form onSubmit={(e) => handleUpdateContact(e, false)}>
                        <div className="form_group">
                          <label className="form-label"> Contact Number*</label>
                          <input
                            type="number"
                            className="form-control"
                            name="contact_primary"
                            value={updateContactData.contact_primary || ""}
                            onChange={changeContactValue}
                          />
                          {updateContactformErrors.contact_primary && (
                            <div className="error">
                              <span className="text-danger">
                                {updateContactformErrors.contact_primary}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="form_group">
                          <label className="form-label">Registration Number</label>
                          <input
                            type="number"
                            className="form-control"
                            name="registration_number"
                            value={updateContactData.registration_number || ""}
                            onChange={changeContactValue}
                          />
                        </div>
                        <div className="form_group">
                          <label className="form-label">Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={updateContactData.name || ""}
                            onChange={changeContactValue}
                          />
                        </div>
                        <div className="form_group">
                          <label className="form-label">ID</label>
                          <input
                            type="number"
                            className="form-control"
                            name="id"
                            value={updateContactData.id || ""}
                            onChange={changeContactValue}
                          />
                        </div>
                        <div className="form_group">
                          <label className="form-label">Parse ID</label>
                          <input
                            type="text"
                            className="form-control"
                            name="parse_id"
                            value={updateContactData.parse_id || ""}
                            onChange={changeContactValue}
                          />
                        </div>
                        <div className="form_group">
                          <label className="form-label">City ID</label>
                          <input
                            type="text"
                            className="form-control"
                            name="city_id"
                            value={updateContactData.city_id || ""}
                            onChange={changeContactValue}
                          />
                        </div>
                        <div className="form_group">
                          <label className="form-label">Vertical Type</label>
                          <select id="source-type" name="vertical_type" value={updateContactData.vertical_type || ""}
                            onChange={(e) => {
                              const v = e.target.value;
                              setUpdateContactData((prev) => ({
                                ...prev,
                                vertical_type: v,
                                caller_type: "",
                                interaction_category: "",
                                interaction_sub_category: "",
                                interaction_type: ""
                              }));
                            }}>
                            <option value="" disabled selected>Select Vertical Type</option>
                            {OPTIONS_VERTICAL_TYPE.map((item) => (
                              <option key={item.value} value={item.value}>{item.label}</option>
                            ))}
                          </select>
                          {updateContactformErrors.vertical_type && (
                            <div className="error">
                              <span className="text-danger">
                                {updateContactformErrors.vertical_type}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="form_group">
                          <label className="form-label">Consignment/Ride/Order ID</label>
                          <input
                            type="text"
                            className="form-control"
                            name="order_id"
                            value={updateContactData.order_id || ""}
                            onChange={changeContactValue}
                          />
                        </div>
                        <div className="form_group">
                          <label className="form-label">Caller Type</label>
                          <select id="caller-type"
                            name="caller_type"
                            value={updateContactData.caller_type || ""}
                            onChange={changeContactValue}>
                            <option value="" disabled selected>Select Caller Type</option>
                            {(CALLER_TYPE_OPTIONS?.[updateContactData.vertical_type] || []).map((type, index) => (
                              <option key={type.value} value={type.value}>{type.label}</option>
                            ))}
                          </select>
                          {updateContactformErrors.caller_type && (
                            <div className="error">
                              <span className="text-danger">
                                {updateContactformErrors.caller_type}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="form_group">
                          <label className="form-label">Interaction Sub Category</label>
                          <select id="source-type" name="interaction_sub_category"
                            value={updateContactData.interaction_sub_category || ""}
                            onChange={(e) => {
                              const selectedValue = e.target.value;

                              const subCategory = getSubCategoriesByVertical(
                                updateContactData.vertical_type
                              ).find((sc) => String(sc.value) === String(selectedValue));

                              setUpdateContactData((prev) => ({
                                ...prev,
                                interaction_sub_category: selectedValue,
                                interaction_category: subCategory?.interaction_category || "",
                                interaction_type: subCategory?.interactionType || ""
                              }));
                            }}>
                            <option value="" disabled> Select Interaction Sub Category </option>
                            {getSubCategoriesByVertical(updateContactData.vertical_type).map((item) => (
                              <option key={item.value} value={item.value}>{item.label}</option>
                            ))}
                          </select>
                          {updateContactformErrors.interaction_sub_category && (
                            <div className="error">
                              <span className="text-danger">
                                {updateContactformErrors.interaction_sub_category}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="form_group">
                          <label className="form-label">Interaction Category</label>
                          <select id="source-type" name="interaction_category"
                            value={updateContactData.interaction_category || ""}
                            onChange={changeContactValue}>
                            <option value="" disabled>Select Interaction Sub Category first</option>
                            {updateContactData.interaction_sub_category &&
                              (INTERACTION_CATEGORY?.[updateContactData.vertical_type] || [])
                                .filter(
                                  (item) =>
                                    String(item.value) ===
                                    String(updateContactData.interaction_category)
                                )
                                .map((item) => (
                                  <option key={item.value} value={item.value}>
                                    {item.label}
                                  </option>
                                ))}
                          </select>
                          {updateContactformErrors.interaction_category && (
                            <div className="error">
                              <span className="text-danger">
                                {updateContactformErrors.interaction_category}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="form_group">
                          <label className="form-label">Interaction Type</label>
                          <select name="interaction_type" value={updateContactData.interaction_type || ""} onChange={changeContactValue}>
                            <option value="" disabled>Select Interaction Sub Category first</option>
                            {updateContactData.interaction_sub_category &&
                              INTERACTION_TYPE_OPTIONS
                                .filter(
                                  (type) =>
                                    String(type.value) ===
                                    String(updateContactData.interaction_type)
                                )
                                .map((type) => (
                                  <option key={type.value} value={type.value}>{type.label}</option>
                                ))}
                          </select>
                          {updateContactformErrors.interaction_type && (
                            <div className="error">
                              <span className="text-danger">
                                {updateContactformErrors.interaction_type}
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="form_group">
                          <label className="form-label">Note</label>
                          <textarea className="form-control" name="note" value={updateContactData.note || ""}
                            onChange={changeContactValue} rows={4} style={{ height: "100px" }} />
                        </div>
                        <div className="form_group">
                          <label className="form-label">Ticket required</label>
                          <select id="source-type" name="ticket_required" value={updateContactData.ticket_required || ""} onChange={changeContactValue}>
                            <option value="" disabled selected>Select Ticket required</option>
                            {ticket_required.map((item, index) => (
                              <option key={index} value={item.value}>{item.label}</option>
                            ))}
                          </select>
                          {updateContactformErrors.ticket_required && (
                            <div className="error">
                              <span className="text-danger">
                                {updateContactformErrors.ticket_required}
                              </span>
                            </div>
                          )}
                        </div>

                        <button className="btn btn-primary" type="submit" disabled={loading}> Submit </button>
                      </form>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 d-flex flex-column">
                    <div className="block-widget">
                      <ScriptDetail
                        scriptData={{
                          script_name: campaignData?.scripts?.script_name,
                          short_desc: campaignData?.scripts?.short_desc,
                          script_text: campaignData?.scripts?.script_texts,
                        }}
                      ></ScriptDetail>
                    </div>
                    <div className="block-widget mt-3" style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                      <h5 className="mb-2">Last Call Dispositions</h5>
                      <table className="table table-bordered table-sm">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Vertical Type</th>
                            <th>Caller Type</th>
                            <th>Interaction Category</th>
                            <th>Interaction Sub Category</th>
                          </tr>
                        </thead>

                        <tbody>
                          {dispositionData.length > 0 ? (
                            dispositionData.map((item) => (
                              <tr key={item.id}>
                                <td>{item.created_at.split(" ")[0]}</td>
                                <td>{getLabel("vertical_type", item.vertical_type)}</td>
                                <td>{getLabel("caller_type", item.caller_type, item.vertical_type)}</td>
                                <td>{getLabel("interaction_category", item.interaction_category, item.vertical_type)}</td>
                                <td>{getLabel("interaction_sub_category", item.interaction_sub_category, item.interaction_category)}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center">
                                No recent dispositions
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4">
                    <div className="block-widget">
                      <div
                        style={{
                          maxHeight: "300px",
                          overflowY: "auto",
                          width: "100%",
                        }}
                      >
                        <table
                          className="table table-striped"
                          style={{ width: "100%", tableLayout: "fixed" }}
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "33%" }}>Agent name</th>
                              <th style={{ width: "33%" }}>Remark</th>
                              <th style={{ width: "33%" }}>Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.isArray(notes) && notes.length > 0 ? (
                              notes.map((note, index) => (
                                <tr key={note.id}>
                                  <td
                                    style={{
                                      width: "33%",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    {note["UserDetail.Agents.agent_name"] || ""}
                                  </td>
                                  <td
                                    style={{
                                      width: "33%",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    {getPlainText(note.note)}
                                  </td>
                                  <td
                                    style={{
                                      width: "33%",
                                      wordWrap: "break-word",
                                    }}
                                  >
                                    {note.created_at}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="3" className="text-center">
                                  No data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <h2>Phone</h2>
                      <div className="phone-block mt-3">
                        <div id="output">
                          <div id="incoming-number"></div>
                          <input type="text" id="numberToCall" />
                        </div>
                        <div className="number-flex">
                          <div className="digit box" id="one">
                            <button className="keypad not-visible">1</button>
                          </div>
                          <div className="digit box" id="two">
                            <button className="keypad not-visible">2</button>
                            <div className="sub">ABC</div>
                          </div>
                          <div className="digit box" id="three">
                            <button className="keypad not-visible">3</button>
                            <div className="sub">DEF</div>
                          </div>
                        </div>
                        <div className="number-flex">
                          <div className="digit box" id="four">
                            <button className="keypad not-visible">4</button>
                            <div className="sub">GHI</div>
                          </div>
                          <div className="digit box" id="five">
                            <button className="keypad not-visible">5</button>
                            <div className="sub">JKL</div>
                          </div>
                          <div className="digit box">
                            <button className="keypad not-visible">6</button>
                            <div className="sub">MNO</div>
                          </div>
                        </div>
                        <div className="number-flex">
                          <div className="digit box">
                            <button className="keypad not-visible">7</button>
                            <div className="sub">PQRS</div>
                          </div>
                          <div className="digit box">
                            <button className="keypad not-visible">8</button>
                            <div className="sub">TUV</div>
                          </div>
                          <div className="digit box">
                            <button className="keypad not-visible">9</button>
                            <div className="sub">WXYZ</div>
                          </div>
                        </div>
                        <div className="number-flex">
                          <div className="digit box">
                            <button className="keypad not-visible">*</button>
                          </div>
                          <div className="digit box">
                            <button className="keypad not-visible">0</button>
                          </div>
                          <div className="digit box">
                            <button className="keypad not-visible">#</button>
                          </div>
                        </div>
                        <div className="number-flex">
                          <div className="digit box hold">
                            <input
                              type="checkbox"
                              className="not-visible"
                              id="hold"
                            />
                            <i className="icon-pause"></i>
                          </div>
                          <div className="digit box">
                            <button className="keypad not-visible">+</button>
                          </div>
                          <div className="digit box mute">
                            <input
                              type="checkbox"
                              className="not-visible"
                              id="mute"
                            />
                            <i className="icon-mic"></i>
                          </div>
                        </div>
                        <div className="botrow">
                          <div className="call reject" id="hangup" disabled>
                            <button className="not-visible">
                              <i className="icon-phone" aria-hidden="true"></i>
                            </button>
                          </div>
                          <div className="call answer" id="call">
                            <button className="not-visible">
                              <i className="icon-phone" aria-hidden="true"></i>
                            </button>
                          </div>

                          <i
                            className="icon-arrow-left backspace"
                            aria-hidden="true"
                          >
                            {" "}
                          </i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="d-flex justify-content-end my-2">
                  <button
                    className="btn btn-primary"
                    onClick={() => handleUpdateContact(null, true)}
                    disabled={loading}
                  >
                    Submit and Call next
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactCallPage;
